var map = {
	"./About": 27,
	"./About.css": 43,
	"./About.js": 27,
	"./Blog": 28,
	"./Blog.js": 28,
	"./Blog1.css": 68,
	"./LandingPage": 26,
	"./LandingPage.css": 42,
	"./LandingPage.js": 26,
	"./LandingPage0424": 25,
	"./LandingPage0424.css": 41,
	"./LandingPage0424.js": 25,
	"./data": 3,
	"./data.js": 3,
	"./images/LinkedIn24.jpg": 69,
	"./images/Screenshot 2021-06-09 085604.png": 70,
	"./images/avatar.jpg": 71,
	"./images/connect.png": 72,
	"./images/github.png": 73,
	"./images/grad.png": 74,
	"./images/grad2.png": 75,
	"./images/grad3.png": 76,
	"./images/hedgehog.png": 77,
	"./images/hello2.png": 78,
	"./images/originals/PastelGradientPreview.webp": 79,
	"./images/originals/TF original.png": 80,
	"./images/originals/batman.gif": 81,
	"./images/originals/connect.png": 82,
	"./images/originals/grad2.jpg": 83,
	"./images/originals/output-onlinepngtools.png": 84,
	"./images/originals/tf logo - Copy.png": 85,
	"./images/originals/tf logo.png": 86,
	"./images/originals/tfosqp.webp": 87,
	"./images/originals/tfosqp2.webp": 88,
	"./images/originals/yaksha.png": 89,
	"./images/scriberx.jpg": 90,
	"./images/self.jpg": 91,
	"./images/selfimg.jpg": 92,
	"./images/test.jpg": 93,
	"./images/yaksha.png": 94,
	"./test.png": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;